<template>
    <div>
        <CardBase>
            <MacroSubHeader
                title="Prazos de pagamento"
                icon="el-icon-office-building"
            >
                <template slot="actions">
                    <el-button
                        size="small" 
                        type="primary"
                        @click="openModal"
                    >
                        <i class="fa fa-plus"></i>
                        Adicionar
                    </el-button>
                </template>
            </MacroSubHeader>

            <!-- Filters -->
            <div class="d-flex align-items-center justify-content-between px-3 mt-3" :style="{ gap: '20px' }">
                <div class="d-flex align-items-center" :style="{ gap: '8px', width: '375px' }">
                    <el-input
                        v-model="filters.search"
                        size="small"
                        placeholder="Buscar regiões"
                        prefix-icon="el-icon-search"
                        clearable
                        :style="{ maxWidth: '375px' }"
                        @keyup.enter.native.prevent="setFiltersprazoPagamentoList()"
                    />

                    <el-button
                        size="small" 
                        type="primary"
                        circle
                        @click="setFiltersprazoPagamentoList()"
                    >
                        <i class="el-icon-search"></i>
                    </el-button>
                </div>

                <div class="d-flex justify-content-end">
                    <el-dropdown size="mini" split-button plain @command="handleSetOrder">
                        <strong>Ordernar</strong>: {{ filters.orderBy == 'latest' ? 'Recentes' : 'Antigos' }}
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="latest">
                                <div class="d-flex align-items-center">
                                    <i class="el-icon-top mr-2"></i>
                                    Mais Recentes
                                </div>
                            </el-dropdown-item>
                            <el-dropdown-item command="oldest">
                                <div class="d-flex align-items-center">
                                    <i class="el-icon-bottom mr-2"></i>
                                    Mais Antigos
                                </div>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>

            <CardBase>
                <PrazoPagamentoList ref="prazoPagamentoListView"/>
            </CardBase>
        </CardBase>

        <!-- PrazoPagamentoCreateModal -->
        <PrazoPagamentoCreateModal ref="prazoPagamentoCreateModal" @created="handleDispatch"/>
    </div>
</template>

<script>    
    //Components
    import 
    {
        Dropdown,
        DropdownMenu,
        DropdownItem
    } from 'element-ui'

    import MacroSubHeader from "@/components/_macro/MacroSubHeader.vue";
    import CardBase from "@/components/_macro/CardBase.vue";

    import PrazoPagamentoList from '@/components/_macro/prazo_pagamento/PrazoPagamentoList.vue';
    import PrazoPagamentoCreateModal from '@/components/_macro/prazo_pagamento/PrazoPagamentoCreateModal.vue';

    export default {
        name: "prazos-pagamento",
        data() {
            return {
                filters: {
                    search: '',
                    orderBy: 'latest',
                }
            }
        },
        methods: {
            openModal() {
                this.$refs.prazoPagamentoCreateModal.toggleModal();
            },
            async handleDispatch() {
                await this.$refs.prazoPagamentoListView.fetch();
            },
            /**Filters */
            async handleSetOrder(orderBy) {
                this.filters.orderBy = orderBy;
            },
            setFiltersprazoPagamentoList() {
                this.$set(this.$refs.prazoPagamentoListView.filters, 'search', this.filters.search);
            }, 
        },
        watch: {
            "filters.orderBy": {
                handler(_newValue, _oldValue) {
                    this.$set(this.$refs.prazoPagamentoListView.filters, 'orderBy', _newValue);
                }
            },
        },
        components: {
            CardBase,
            MacroSubHeader,
            PrazoPagamentoList,
            PrazoPagamentoCreateModal,
            [Dropdown.name]: Dropdown,
            [DropdownMenu.name]: DropdownMenu,
            [DropdownItem.name]: DropdownItem,
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/adm_prazos/Index.vue